import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Phase from 'src/store/models/Phase';
import EntityPicker from 'src/components/Pickers/Picker';
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: ['project_id', 'onComplete', 'name'],
  components: {
    EntityPicker: EntityPicker,
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      myPhase: {
        name: this.name,
        category_id: null,
        budget: null
      },
      loading: false
    };
  },
  methods: {
    savePhase: function savePhase() {
      var _this = this;

      var data = {
        name: this.myPhase.name,
        budget_minutes: this.myPhase.budget ? this.myPhase.budget : 0,
        project_id: this.project_id
      };

      if (this.myPhase.category_id > 0) {
        data.task_category_id = this.myPhase.category_id;
      }

      this.loading = true;
      var url = '/phases',
          method = 'post';
      Phase.api()[method](url, data).then(function (result) {
        _this.loading = false;

        _this.$q.notify({
          message: _this.$t('components.createPhaseDialog.created_last_phase'),
          type: 'positive'
        });

        _this.onOKClick(result.response.data);
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);

        _this.$q.notify({
          message: _this.$t('components.createPhaseDialog.error_creating_phase'),
          type: 'negative'
        });
      });
    }
  }
};